<template>
    <el-dialog 
			:visible.sync="showModal" 
			:width="(device == 'xs' ? '97%' : width)" 
			:close-on-press-escape="closeESC"
			:close-on-click-modal="closeCLICK"
      :modal="isModal"
      @close="handlerClose" 
		> 
      <span slot="title" class="modal-title">
        {{title.toUpperCase()}}
      </span>
      <el-row v-loading="loading">
        <slot name="modal-content"/>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <ed-button 
          v-if="onSave" 
          type="primary" 
          @click="onSave()" 
          :loading="loadingSave"
          :icon="saveIcon"
          :value="saveName"
        />
        <ed-button 
          type="danger" 
          v-on:click="showModal = false"
          icon="fa fa-window-close"
          value="Fechar"
        />
      </span>
    </el-dialog>
</template>

<script>
  import Session from 'common/session'
  import EdButton from 'common/button'

  export default {
      name:"ed-modal",
      components:{EdButton},
      mixins:[Session],
      props:{
        title:{
          type:String,
          default:'Modal'
        },
        modal:{
          type:Boolean,
          default:false
        },
        loadingSave:{
          type:Boolean,
          default:false
        },
        loading:{
          type:Boolean,
          default:false
        },
        width:{
          type:String,
          default:'95%'
        },
        saveIcon:{
          type:String,
          default:'fa fa-save'
        },
        closeESC:{
          type:Boolean,
          default:false
        },
        isModal:{
          type:Boolean,
          default:true
        },
        closeCLICK:{
          type:Boolean,
          default:false
        },
        lodingSave:{
          type:Boolean,
          default:false
        },
        saveName:{
          type:String,
          default:'Salvar'
        },
        onSave:{
          type:Function,
          default:null
        },
        onClose:{
          type:Function,
          default:null
        },

      },
      watch:{
        title(){
        },
        modal(){
          this.showModal = !this.showModal;
        },
        loading(){
        },
        loadingSave(){
        },
        width(){
        },
        saveIcon(){
        },
        closeESC(){
        },
        isModal(){
        },
        closeCLICK(){
        },
        lodingSave(){
        },
        saveName(){
        },
        onSave(){
        }
      },

      data() {
        return {
          showModal:false,
        }
      },
      mounted() {
      },
    
      methods:{

        handlerClose(){
          if(this.onClose){
            this.onClose();
          }
          else{
            this.showModal = false
          }
        }
      }
  }
</script>

<style lang="scss">
  .modal-title{
    font-weight: bold;
    color:#fff;
    font-size: 16px;
  }
  .el-dialog__header{
    background: var(--primary) !important;
  }
  .el-dialog__close,.el-icon el-icon-close{
    color:#fff !important;
  }
</style>


// WEBPACK FOOTER //
// EdModal.vue?612ecf2b